import { render, staticRenderFns } from "./CartBreadcumbs.vue?vue&type=template&id=40230778&"
import script from "./CartBreadcumbs.vue?vue&type=script&lang=js&"
export * from "./CartBreadcumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports